<collab-comp-card *ngIf="productDetails">
    <div header class="header">
        <collab-comp-img-generator imageType="image" [imgUrl]="getUrl(productDetails?.assetUrls?.panelImage)"  imageAltText="image of {{productDetails?.productCode}} "></collab-comp-img-generator>
        <div  *ngIf="productDetails?.productCode === 'ITA' || productDetails?.productCode === 'IAF'" class="statusText">New</div>
    </div>
    <div content>
        <div>
            <h2 class="text--name">{{ productDetails?.productName }}</h2>
            <div class="text--accent-primary-alt margin__top--75 margin__bottom--225">{{ productDetails?.category }}</div>
            <div class="" *CheckPermissions="page; name:'View the description of the Studio Cards'">{{
                productDetails?.description }}</div>
            <div class="expired-text" *ngIf="isTrialExpiredAndBuyNow">Trial Expired!</div>
        </div>
        <div class="expired-text" *ngIf="isLaunchTrail && productDetails?.trialPeriod?.daysRemaining" >
            Trial Period : {{ productDetails?.trialPeriod?.daysRemaining }} days remaining</div>

        <app-video-container id="{{productDetails?.productCode}}" [productDetails]="productDetails" [modalConfig]="modalConfig">
            <app-video [videoUrl]="videoUrl" [posterUrl]="posterUrl" 
            [id]="productDetails?.productCode"></app-video>
        </app-video-container>
    </div>

    <div footer>
        <div class="container__row--space-between--center">
            <collab-comp-button type="button" class="" *ngIf="isTrialExpiredAndBuyNow" [buttonConfig]="buyNowBtnConfig"></collab-comp-button>
            <div *ngIf="showStartTrail && productDetails?.productCode!=='Data Modernization' && productDetails?.productCode!=='AIPOs'">
                <collab-comp-button class="button--trial" type="button" *ngIf="productDetails?.productCode === 'ITA' ||productDetails?.productCode === 'IAF'; else start_trial_launch"
                                    (click)="getStartTrailDetails(productDetails?.productId, productDetails?.productCode)" [buttonConfig]="startTrailBtnConfig">
                </collab-comp-button>

                <ng-template #start_trial_launch>
                    <collab-comp-button type="button" class="button--trial"
                                        (click)="getStartTrailDetails(productDetails?.productId, productDetails?.productCode)" [buttonConfig]="startTrailBtnConfig">
                    </collab-comp-button>
                </ng-template>
            </div>

            <div *ngIf="isLaunchTrail">
                <collab-comp-button type="button" class="small_button" *ngIf="productDetails?.productCode === 'ITA' ||productDetails?.productCode === 'IAF'; else launch_trial"
                                    (click)="goTo(productDetails?.productUrl)" [buttonConfig]="launchTrailBtnConfig">
                </collab-comp-button>
                <ng-template #launch_trial>
                    <collab-comp-button type="button" (click)="goTo(productDetails?.productUrl)" [buttonConfig]="launchTrailBtnConfig">
                    </collab-comp-button>
                </ng-template>
            </div>

            <div  *ngIf="showStartTrail && productDetails?.productCode!=='Data Modernization' && productDetails?.productCode!=='ADE' && productDetails?.productCode!=='AIPOs'">
                <collab-comp-button type="button" class="button--demo button--secondary  container__row--space-between--center"  *ngIf="productDetails?.productCode === 'ITA' ||productDetails?.productCode === 'IAF'; else other_demo"
                                    (click)="openVideoPlayer(productDetails)" [buttonConfig]="watchButtonBtnConfig">
                </collab-comp-button>
                <ng-template #other_demo>
                    <collab-comp-button type="button" class="button--demo button--secondary"  (click)="openVideoPlayer(productDetails)" [buttonConfig]="watchButtonBtnConfig">
                    </collab-comp-button>
                </ng-template>
            </div>
        </div>

        <div class="contentRight__longButton" *ngIf="isLaunchEnable ||productDetails?.productCode==='Data Modernization'">
            <ng-container *ngIf="productDetails?.productCode === 'ITA' ||productDetails?.productCode === 'IAF'; else other_launch">
                <collab-comp-button type="button" class="launch-btn" (click)="goTo(productDetails?.productUrl)"
                                    *CheckPermissions="page; name:productDetails.launchPermission" [buttonConfig]="LaunchApplicationBtnConfig"></collab-comp-button>
            </ng-container>
            <ng-template #other_launch>
                <collab-comp-button type="button" class="launch-btn" (click)="goTo(productDetails?.productUrl)" [buttonConfig]="LaunchApplicationBtnConfig"></collab-comp-button>
            </ng-template>
        </div>
        <div class="contact-us-opacity container__row--space-between--center" *ngIf="showContactUs&&productDetails?.productCode!=='AIPOs' && productDetails?.productCode!=='ADE'">
            <collab-comp-button type="button"  *CheckPermissions="'Landing Page'; name:'MLOps Contact Us'"
                                (click)="gotoContactUs()" [buttonConfig]="contactUsBtnConfig"></collab-comp-button>
                    
            <collab-comp-button type="button" 
                                (click)="gotoMLops()" [buttonConfig]="watchButtonBtnConfig"></collab-comp-button>

        </div>
        <div class="" *ngIf="productDetails?.productCode==='AIPOs' ||( showContactUs &&productDetails?.productCode==='ADE')">
            <collab-comp-button type="button"  
            (click)="gotoContactUs()" [buttonConfig]="contactUsBtnConfig"></collab-comp-button>
        </div>
    </div>
</collab-comp-card>
<div *ngIf="modalData">
    <collab-comp-modal [id]="'product' + productDetails?.productId" [modalConfig]="modalConfig"
        (onClose)="done('product' + productDetails?.productId)" (primaryButtonSelected)="startFreeTrail(productDetails?.productId)" >
            <div  class="startTrail">
                <div class="trail-message">
                    <p class="heading_container">Trial for 30 days</p>
                    <h2>{{modalData.header}}</h2>
                    <p>{{modalData.content}}</p>
                </div>
            </div>
            <div class="trail-middle"> What you get this for trial </div>

            <div class="trail-bottom">
                <p> {{modalData.statement}}</p>
                <ul>
                    <li *ngFor="let action of modalData.actions">
                        <collab-comp-img-generator imageType="icon" fontClassName="icon-Arrow-Right"></collab-comp-img-generator>
                        <span>{{action}}</span>
                    </li>
                </ul>
            </div>        
    </collab-comp-modal>
</div>
<div *ngIf="modalData">
    <collab-comp-modal [id]="'trial-success'" [modalConfig]="trialModalConfig" (onSubmitted)="done('trial-success')" (onClose)="closeModal('trial-success')" [buttonConfig]="okBtnConfig">
        <div class="trail-message trial-success">
            <collab-comp-img-generator fontClassName='icon-Success text--success icon--xxl'>
            </collab-comp-img-generator>
            <h1>Congratulations!</h1>
            <p>Your trial has successfully started.</p>
            <p class="expiry">Expiry Date : <span>{{landingPageService.trialExpiryDate}}</span></p>
        </div>
    </collab-comp-modal>
</div>
